/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


/**
 * UI Modals
 * Proxy to magnificPopup.js
 * Documentation: http://dimsemenov.com/plugins/magnific-popup/documentation.html
 */

define('global/UI/Modal',[
    'jquery',
    'global/Logger',
    'plugins/magnific-popup'
],
function ($, Logger) {
    'use strict';

    /**
     * Listener for basic front-end triggering
     *
     * Example 1: <button data-roc-modal="#id-of-inline-markup">Show Modal</button>
     * Example 2: <button data-roc-modal="<p>Modal content text</p>">Show Modal</button>
     */
    function init() {
        $('.site-container').on('click', '[data-roc-modal]', function (e) {
            var data = $(e.currentTarget).data();

            // Open directly via API        
            $.magnificPopup.open({
                items: {
                    src: data.rocModal,
                    type: data.rocModalType || 'inline'
                }
            });

            initCloseButton();
        });
    };


    function initCloseButton() {
        // get reference for current open modal
        var magnificPopup = $.magnificPopup.instance;

        // find element to use to 'close' the modal if they exist
        $(magnificPopup.content).find('[data-roc-modal-trigger="close"]').click(function (e) {
            $.magnificPopup.close();
        });
    };


    /**
     * Open modal directly via API
     * 
     * @param {string} content - required
     * @param {string} contentType - optional
     * @param {object} callbackObjects - optional
     * @param {boolean} hideDefaultCloseBtn - optional, if we want to hide default (x) close button 
     * and to disable closing by clicking outside modal
     * 
     */
    function open(content, callbackObjects, hideDefaultCloseOptions) {
        // open modal
        $.magnificPopup.open({
            items: {
                src: content,
                type: 'inline'
            },
            callbacks: callbackObjects || {},
            closeOnBgClick: !hideDefaultCloseOptions,
            showCloseBtn: !hideDefaultCloseOptions
        });

        initCloseButton();
    };

    // Closes any currently displayed modal
    function close() {
        $.magnificPopup.close();
    };


    function alert(content, title, callbackObjects) {
        var modalContent;

        modalContent = '<div id="modal-alert" class="white-popup">';
        modalContent += '    <div class="modal-header">';
        modalContent += '        <h2 class="title">';
        modalContent += title || 'Error';
        modalContent += '        </h2>';
        modalContent += '    </div>';
        modalContent += '    <div class="modal-body"><p>' + content + '</p></div>';
        modalContent += '    <div class="modal-footer">';
        modalContent += '        <button class="btn btnDefault" data-roc-modal-trigger="close" type="button">Ok</button>';
        modalContent += '    </div>';
        modalContent += '</div>';

        open(modalContent, callbackObjects)
    };

    var Modal = {
        init: init,
        open: open,
        close: close,
        alert: alert
    };

    Logger.debug('Modals.js Loaded:', Modal);

    // initialize modal listener
    init();

    // return public functions
    return Modal;
});

